import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AdminLayout from '../Componets/AdminLayout';
import DataTable from 'react-data-table-component';
import { ToastContainer, toast } from 'react-toastify';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

export default function ListSection() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id, subjectId, subjectname, examTotalMarks } = location.state || {};
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [count, setCount] = useState(0);
  const [totalMarksSum, setTotalMarksSum] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    fetchSectionData();
  }, [id, subjectId]);

  const fetchSectionData = () => {
    setLoading(true);
    const token = localStorage.getItem('token');

    axios
      .get(`${apiUrl}/api/section/${id}/${subjectId}`, {
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        const sections = res.data.sections;
        calculateTotalMarksSum(sections);
        setLoading(false);

        const summaryRow = {
          id: 'summary',
          name: 'Total Marks for All Sections:',
          totalMarks: totalMarksSum,
        };
        setData([...sections, summaryRow]);
        setCount(res.data.count);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        err.response?.status === 401 && navigate('/');
      });
  };

  const calculateSectionStats = (section) => {
    let totalMarks = 0;
    let numQuestions = 0;

    section.questions.forEach((question, index) => {
      if (question.isAnyQus && index < question.noOfAnyQus) {
        totalMarks += question.marks;
        numQuestions = question.noOfAnyQus;
      } else if (!question.isAnyQus) {
        totalMarks += question.marks;
        numQuestions += 1;
      }
    });

    return { totalMarks, numQuestions };
  };

  const calculateTotalMarksSum = (sections) => {
    const sum = sections.reduce(
      (acc, section) => acc + calculateSectionStats(section).totalMarks,
      0
    );
    setTotalMarksSum(sum);
  };

  const handleDeleteSection = (sectionId) => {
    if (window.confirm('Are you sure you want to delete this section?')) {
      const token = localStorage.getItem('token');

      axios
        .delete(`${apiUrl}/api/section/${sectionId}`, {
          headers: {
            Authorization: token,
          },
        })
        .then((res) => {
          toast.success('Section deleted successfully');
          fetchSectionData();
        })
        .catch((err) => {
          console.error(err);
          toast.error(err.response?.data?.message);
          err.response?.status === 401 && navigate('/');
        });
    }
  };

  const columns = [
    {
      name: 'No.',
      cell: (row, index) => (row.id === 'summary' ? '' : index + 1),
      width: '50px',
      center: 'true',
    },
    {
      name: 'Section Name',
      selector: (row) => (
        <span>
          <strong>{row.name}</strong>
        </span>
      ),
      sortable: true,
    },
    {
      name: 'Section Type',
      width: '180px',
      selector: (row) => (
        <span>
          {row.sectionType} {row.noOfAnyQus > 0 && `${row.noOfAnyQus}`}
        </span>
      ),
      sortable: true,
    },

    {
      name: 'Number of Questions',
      cell: (row) =>
        row.id === 'summary' ? '' : calculateSectionStats(row).numQuestions,
      width: '180px',
      center: 'true',
    },
    {
      name: 'Total Marks',
      cell: (row) =>
        row.id === 'summary'
          ? `${totalMarksSum}/${examTotalMarks}`
          : calculateSectionStats(row).totalMarks,
      width: '180px',
      center: 'true',
    },
    {
      name: 'Actions',
      width: '115px',
      center: 'true',
      cell: (row) =>
        row.id ? (
          row.id === 'summary' ? null : (
            <div>
              <button
                className="btn btn-primary btn-sm mx-2"
                onClick={() =>
                  navigate('/EditSection', {
                    state: { id: row, totalMarksSum, examTotalMarks },
                  })
                }
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Edit Section"
              >
                <i className="bi bi-pencil-square"></i>
              </button>
              <button
                className="btn btn-outline-danger btn-sm"
                onClick={() => handleDeleteSection(row.id)}
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Delete Section"
              >
                <i className="bi bi-trash3-fill"></i>
              </button>
            </div>
          )
        ) : null,
    },
  ];

  return (
    <AdminLayout ac4="active">
      <main id="main" className="main">
        <div className="pagetitle mb-4">
          <nav>
            <ol className="breadcrumb">
              <li
                className="breadcrumb-item cursor-pointer"
                onClick={() => navigate('/AdminHome')}
              >
                Dashboard
              </li>
              <li
                className="breadcrumb-item cursor-pointer"
                onClick={() => navigate('/ListExam')}
              >
                View Exam
              </li>
              <li
                className="breadcrumb-item cursor-pointer"
                onClick={() => navigate(-1)}
              >
                Exam Subjects
              </li>
              <li className="breadcrumb-item active">
                Section List of {subjectname} ({count})
              </li>
            </ol>
          </nav>
        </div>
        <hr className="mb-0" />
        <section className="section col-lg-12">
          <div className="row">
            <div className="container">
              <div className="datatable-top">
                <div className="datatable-search">
                  <input
                    className="form-control"
                    type="search"
                    name="totalMarks"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Search"
                    title="Search within table"
                  />
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() =>
                      navigate('/AddSection', {
                        state: { id: id, subjectId: subjectId },
                      })
                    }
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Add New Section"
                  >
                    <i className="bi bi-plus-square"></i>
                  </button>
                </div>
              </div>
              <DataTable
                columns={columns}
                progressPending={loading}
                data={data.filter((item) =>
                  item.name.toLowerCase().includes(searchText.toLowerCase())
                )}
                className="custom-table"
                conditionalRowStyles={[
                  {
                    when: (row) => row.id === 'summary',
                    style: {
                      backgroundColor: '#f8f9fa', // Set your desired background color
                    },
                  },
                ]}
              />

              <ToastContainer position="top-center" style={{ width: 'auto' }} />
            </div>
          </div>
        </section>
      </main>
      <Tooltip id="my-tooltip" />
    </AdminLayout>
  );
}
